module.exports = __webpack_public_path__ + "img/EACalculateItem5.8da09e48.svg";